export enum RespondentCategory {
  OFFICER_DIRECTOR = 'Director and Executive Officer',
  DIRECTOR = 'Director',
  EXECUTIVE_OFFICER = 'Executive Officer',
  SHARE_HOLDER = '5 percent Shareholder',
}
